import { Navigate } from "react-router-dom";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";

/**
 * @function PrivateRoute
 * @description for PrivateRoute
 * @returns JSX for PrivateRoute
 */

const PrivateRoute = ({ children }) => {
  const AuthReducer = useSelector((store) => store.AuthReducer);
  const location = useLocation();
  if (!AuthReducer?.accessToken) {
    return <Navigate to="/" state={{ from: location }} />;
  }
  return children;
};
export default PrivateRoute;
